import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook that provides localized placeholder text for date-time inputs.
 * It replaces format tokens with their translated equivalents from i18n files.
 * The translation team can update the tokens in the locale JSON files.
 */
export function useDateTimePlaceholder(inputFormat: string): string {
  const { t } = useTranslation();

  return useMemo(() => {
    // Map format tokens to their translation keys
    const tokenToTranslationKey: Record<string, string> = {
      YYYY: t('dateTime.placeholder.year'),
      MM: t('dateTime.placeholder.month'),
      DD: t('dateTime.placeholder.day'),
      hh: t('dateTime.placeholder.hour'),
      mm: t('dateTime.placeholder.minute'),
      A: t('dateTime.placeholder.period'),
    };

    // Replace format tokens with localized equivalents
    let localizedFormat = inputFormat;

    Object.keys(tokenToTranslationKey).forEach((token) => {
      localizedFormat = localizedFormat.replace(
        new RegExp(token, 'g'),
        tokenToTranslationKey[token],
      );
    });

    return localizedFormat.toLowerCase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputFormat]);
}
